/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class HistoryService {
        constructor(private $http: angular.IHttpService, private $q: angular.IQService) {

        }

        public getFormFieldHistory(processId: string, formDataId: string, uniqueId: string): angular.IPromise<Wars.Domain.Model.Dtos.HistoryDto[]> {
            var d = this.$q.defer();

            this.$http.get('./api/Process/' + processId + '/FormDataHistory/' + formDataId + '/' + uniqueId).then(r => {
                d.resolve(r.data);
            });
            return d.promise;
        }

        public getProcessDataHistory(processId: string, uniqueId: string): angular.IPromise<Wars.Domain.Model.Dtos.HistoryDto[]> {
            var d = this.$q.defer();

            this.$http.get('./api/Process/' + processId + '/ProcessDataHistory/' + uniqueId).then(r => {
                d.resolve(r.data);
            });
            return d.promise;

        }
        public getListFormFieldHistory(processId: string, formDataId: string, listId: string, rowId: string, propertyId: string): angular.IPromise<Wars.Domain.Model.Dtos.HistoryDto[]> {
            var d = this.$q.defer();

            this.$http.get('./api/Process/' + processId + '/ListFormDataHistory/' + formDataId + '/' + listId + '/' + rowId + '/' + propertyId).then(r => {
                d.resolve(r.data);
            });
            return d.promise;
        }

        public getListProcessDataHistory(processId: string, listId: string, rowId: string, propertyId: string): angular.IPromise<Wars.Domain.Model.Dtos.HistoryDto[]> {
            var d = this.$q.defer();

            this.$http.get('./api/Process/' + processId + '/ListProcessDataHistory/' + listId + '/' + rowId + '/' + propertyId).then(r => {
                d.resolve(r.data);
            });
            return d.promise;

        }
    }
}

warsApp.registerService('HistoryService', ['$http', '$q']);